// src/pages/SignIn.jsx
import React, { useState } from "react";
import { Button, Form, Input, Card, Typography, message } from "antd";
import { useAuth } from "../context/AuthContext";
import { useLocation } from "wouter";

const { Title, Text } = Typography;

const SignIn = () => {
  const { login } = useAuth();
  const [, setLocation] = useLocation();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    const { email, password } = values;
    setLoading(true);
    try {
      await login(email, password);
      message.success("Connexion réussie !");
      setTimeout(() => {
        setLocation("/");
      }, 500);
    } catch (err) {
      console.error("Erreur de connexion:", err);
      message.error("Email ou mot de passe incorrect");
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = () => {
    // Validation failed
  };

  return (
    <div className="auth-page-container">
      <Card
        className="auth-card"
        classNames={{ header: "auth-card-header", body: "auth-card-body" }}
      >
        <div className="auth-title-wrapper">
          <Title level={2} style={{ color: "var(--brand-primary)", marginBottom: 8 }}>
            <span className="brand-bio">Bio</span>
            <span className="brand-connect">Connect</span>
          </Title>
          <Text className="auth-subtitle">Connectez-vous à votre compte</Text>
        </div>

        <Form
          form={form}
          layout="vertical"
          name="signin"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            label={<span className="form-label-light">Email</span>}
            name="email"
            rules={[
              { required: true, message: "Veuillez saisir votre email !" },
              { type: "email", message: "Email invalide !" }
            ]}
          >
            <Input
              size="large"
              placeholder="votre@email.com"
              className="input-dark"
            />
          </Form.Item>

          <Form.Item
            label={<span className="form-label-light">Mot de passe</span>}
            name="password"
            rules={[{ required: true, message: "Veuillez saisir votre mot de passe !" }]}
          >
            <Input.Password
              size="large"
              placeholder="••••••••"
              className="input-dark"
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              loading={loading}
              block
              className="btn-submit-primary"
            >
              Se connecter
            </Button>
          </Form.Item>
        </Form>

        <div className="auth-link-area">
          <Text className="text-dark">Pas encore de compte ? </Text>
          <Button
            type="link"
            onClick={() => setLocation("/signup")}
            className="btn-link-brand"
          >
            S'inscrire
          </Button>
        </div>

        <div className="auth-link-area-secondary">
          <Text className="text-dark">Mot de passe oublié ? </Text>
          <Button
            type="link"
            onClick={() => setLocation("/recover-pwd")}
            className="btn-link-brand"
          >
            Réinitialiser
          </Button>
        </div>

        <div className="auth-footer-divider">
          <Text className="text-small-secondary">
            BioConnect - Système de gestion d'irrigation intelligent
          </Text>
        </div>
      </Card>
    </div>
  );
};

export default SignIn;
